import { render, staticRenderFns } from "./PayOutTest.vue?vue&type=template&id=5d89d712&scoped=true"
import script from "./PayOutTest.vue?vue&type=script&lang=js"
export * from "./PayOutTest.vue?vue&type=script&lang=js"
import style0 from "./PayOutTest.vue?vue&type=style&index=0&id=5d89d712&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d89d712",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d89d712')) {
      api.createRecord('5d89d712', component.options)
    } else {
      api.reload('5d89d712', component.options)
    }
    module.hot.accept("./PayOutTest.vue?vue&type=template&id=5d89d712&scoped=true", function () {
      api.rerender('5d89d712', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/api/components/PayOutTest.vue"
export default component.exports